import React from 'react'
import { logos } from '../Assets/Logos/logos'

export default function StartupModal({ isOpen, onClose }) {
  if (!isOpen) {
    return null
  }

  return (
    <div className="startup-modal-overlay" role="dialog" aria-modal="true">
      <div className="startup-modal-content">
        <button
          type="button"
          className="startup-modal-close"
          onClick={onClose}
          aria-label="Fechar aviso"
        >
          ×
        </button>

        <p className="startup-modal-badge">NOVIDADE</p>
        <img
          src={logos.ximedCompleto}
          alt="Logo XIMED"
          className="startup-modal-logo"
        />

        <h2>Estamos de cara nova!</h2>
        <p>
          A AMMARHES agora faz parte do grupo XIMED Saúde
          Ocupacional, com a mesma confiança de sempre e ainda mais estrutura
          para cuidar da sua empresa.
        </p>

        <div className="startup-modal-evolution">
          <img
            src={logos.ammarhesBlue}
            alt="Logo AMMARHES"
            className="startup-modal-evolution-logo startup-modal-evolution-logo-left"
          />
          <span className="startup-modal-arrow">→</span>
          <div className="startup-modal-evolution-text">EVOLUIU PARA</div>
          <img
            src={logos.ximedCompleto}
            alt="Logo XIMED"
            className="startup-modal-evolution-logo startup-modal-evolution-logo-right"
          />
        </div>

        <button type="button" className="startup-modal-cta" onClick={onClose}>
          Clique aqui e conheça a XIMED
        </button>
      </div>
    </div>
  )
}